import { ValuesSchema } from 'tinybase';
import { createZodSchematizer } from 'tinybase/schematizers/schematizer-zod';
import { z } from 'zod';

import type { TablesSchemaFromZod } from '~/common/types/tinybase';

export const GlobalStoreId = 'global';

export type GlobalStoreZodTables = typeof globalStoreTables;

const schematizer = createZodSchematizer();

/**
 * Zod object schemas are the source of truth for each table. The TinyBase
 * TablesSchema below is generated from them via the Zod schematizer.
 * Global store data is read-only (server-populated).
 */
export const globalStoreTables = {
  buildings: z.object({
    buildingId: z.string(),
    name: z.string(),
    address: z.string(),
    estate: z.string(),
    postcode: z.string(),
    isHighRisk: z.boolean(),
  }),
  fraBlocks: z.object({
    fraId: z.string(),
    buildingId: z.string(),
    name: z.string(),
    isHighRisk: z.boolean(),
  }),
  properties: z.object({
    propertyId: z.number(),
    propertyRef: z.string(),
    buildingId: z.string(),
    fraId: z.string(),
    uprn: z.string(),
    name: z.string(),
    address: z.string(),
    isResidential: z.boolean(),
    occupiedStatus: z.string(),
    tenureType: z.string(),
  }),
  referenceLists: z.object({
    id: z.string(),
    type: z.string(),
    code: z.string(),
    baseType: z.string(),
    description: z.string(),
    /**
     * Inactive values are stored for mapping historical data
     * but are excluded from option lists
     * */
    isActive: z.boolean(),
  }),
  /** Links note types to their applicable subtypes */
  noteTypeSubtypes: z.object({
    id: z.string(),
    type: z.string(),
    subtype: z.string(),
  }),
} as const;

export const globalStoreTablesSchema = schematizer.toTablesSchema(
  globalStoreTables,
) as TablesSchemaFromZod<GlobalStoreZodTables>;

/** The global store has no keyed values */
export const globalStoreValuesSchema = {} satisfies ValuesSchema;
